import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';

@Injectable({
  providedIn: 'root'
})
export class StripeService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/stripe`;

  async getAllStripeCustomers(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<{
    stripeCustomers: any[],
    count: number
  }> {
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => 
      this.http.get<any>(`${this.url}`, { params: params }).toPromise()
    );
  }

  async createStripeCustomer(id): Promise<any> {
    return this.request(() => this.http.post<any>(`${this.url}/customer/${id}`, null).toPromise());
  }

  async attachCard(formData: any): Promise<any> {
    return this.request(() => this.http.post<any>(`${this.url}/attach-card`, (formData)).toPromise());
  }

  async getOne(id: number): Promise<any> {
    return this.request(() => this.http.get<any>(`${this.url}/${id}`).toPromise());
  }

  async getStripeCustomerInformation(id: number): Promise<any> {
    return this.request(() => this.http.get<any>(`${this.url}/customer/find/${id}`).toPromise());
  }

  async setDefaultCard(customerId: string, cardId: string): Promise<any> {
    return this.request(() => this.http.put<any>(`${this.url}/${cardId}`, {customerId}).toPromise());
  }
}
